<template>
  <v-app
    id="app"
    :dark="theme === 'dark'"
    :light="theme === 'light'"
    :style="cssProps"
    :class="{ iframe: inIframe() }"
    class="w-100 h-100 d-flex flex-column"
    style="background: lightgray"
  >
    <v-main
      class="pa-0 d-flex flex-column flex-grow-1 h-100"
      style="width: 500px"
    >
      <v-progress-circular
        v-if="
          !customization &&
          instance &&
          $route.name !== routeNames.PAYMENT_SUCCESS &&
          $route.name !== routeNames.PAYMENT_ERROR
        "
        indeterminate
        color="primary"
        class="absolute-center"
      ></v-progress-circular>
      <router-view
        v-else
        :routeNames="routeNames"
        :auth="auth"
        style="
          max-height: 100%;
          display: flex;
          flex-direction: column;
          flex-grow: 1;
          overflow-y: scroll;
          -webkit-overflow-scrolling: touch;
        "
      />
    </v-main>
    <v-snackbar
      v-if="snackbar.show"
      multi-line
      :timeout="snackbar.message.timeout"
      v-bind:class="{ error_msg: snackbar.message.color === 'error' }"
      :color="snackbar.message.color"
      v-model="snackbar.show"
    >
      <v-row>
        <v-col cols="2">
          <v-btn
            v-bind:class="{ error_btn: snackbar.message.color === 'error' }"
            name="Close message"
            icon
            dark
            text
            @click="snackbar.show = false"
          >
            <v-icon>clear</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="10" class="align-self-center">
          {{ snackbar.message.text }}
        </v-col>
      </v-row>
    </v-snackbar>
  </v-app>
</template>

<script>
import routeNames from "./router/route-names";
import { EventBus } from "./services/event-bus";
import { themeByColor } from "./utils/ColorUtils";
import { AuthService } from "./services/auth.service";
const auth = new AuthService();
const { login, logout } = auth;
import { mapState } from "vuex";
import errorManager from "./services/error.manager";
import "./compiled-icons";

export default {
  data() {
    return {
      auth,
      theme: themeByColor(
        this.$vuetify.theme.themes.light.primary
          ? this.$vuetify.theme.themes.light.primary
          : "#000000"
      ),
      routeNames: routeNames,
      snackbar: {
        message: null,
        show: false,
      },
      minHeight: 550,
    };
  },
  computed: {
    instance() {
      return this.$route.params.instance || this.$store.getters.instanceId;
    },
    cssProps() {
      return {
        "--primary-color": this.$vuetify.theme.themes.light.primary,
        "--secondary-color": this.$vuetify.theme.themes.light.secondary,
        "--text-over-primary": this.$vuetify.theme.themes.light.textOverPrimary,
        "--text-over-secondary":
          this.$vuetify.theme.themes.light.textOverSecondary,
        "--background-start": "#787878cc",
        "--background-end": "#e2e2e2",
        "--transaction-order": "#e95046",
        "--transaction-recharge": "#17aacb",
        "--transaction-refund": "#16116f",
      };
    },
    ...mapState({
      customization: (state) => state.customization.customization,
    }),
  },
  methods: {
    inIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    },
    login,
    logout,
    showMessage(message) {
      this.snackbar.message = message;
      this.snackbar.show = true;
    },
    getCustomization() {
      const context = this;
      this.$store
        .dispatch("getCustomization", {
          context: this,
          getSaved: false,
        })
        .catch((error) => {
          errorManager.manageError(context, error);
        });
    },
  },
  created() {
    this.getCustomization();
    EventBus.$on("showMessage", (message) => this.showMessage(message));
  },
  mounted() {
    this.getCustomization();
  },
  beforeUnmount() {
    EventBus.$off("showMessage");
  },
  watch: {
    instance() {
      this.$store.dispatch("getCustomization", {
        context: this,
        getSaved: false,
      });
    },
  },
};
</script>

<style lang="scss">
::-webkit-scrollbar {
  display: none;
}
::-webkit-scrollbar {
  width: 0px; /* remove scrollbar space */
  background: transparent; /* optional: just make scrollbar invisible */
}
@-moz-document url-prefix() {
  html,
  body {
    overflow: hidden !important;
  }
}
html {
  -ms-overflow-style: none; // IE 10+
  overflow: -moz-scrollbars-none; // Firefox
}
@import url("https://fonts.googleapis.com/css?family=Raleway");
.user-text {
  &.title {
    font-family: "Raleway" !important;
  }
  &.display-2 {
    font-family: "Raleway" !important;
  }
  font-family: "Raleway" !important;
}
.v-card__title.user-text {
  font-family: "Raleway" !important;
}
.v-btn {
  touch-action: manipulation;
}
.v-btn.left .v-btn__content {
  justify-content: start !important;
}

.v-application .theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: var(--primary-color) !important;
  opacity: 0.5;
  color: var(--text-over-secondary) !important;
}
.v-application .theme--light.v-btn.v-btn--disabled .v-icon {
  color: var(--text-over-secondary) !important;
}

.v-speed-dial__list {
  align-items: flex-end !important;
  min-width: fit-content;
  right: 0 !important;
  left: unset !important;
}
@-webkit-keyframes autofill {
  to {
    color: inherit;
    background: transparent;
  }
}

input:-webkit-autofill {
  -webkit-animation-name: autofill;
  -webkit-animation-fill-mode: both;
}
//v2 styles
.nowrap {
  white-space: nowrap;
}
.big-icon {
  font-size: 4.2rem !important;
}
.display {
  font-size: 28px !important;
}
.svg-fill {
  fill: none;
  stroke: currentColor;
}
.vertical-semi-centered {
  margin-top: 40%;
}
.v-application .v-btn {
  font-weight: 200;
}
.input-custom {
  border: 2px solid var(--secondary-color);
  border-radius: 20px !important;
}
.v-btn {
  text-transform: none !important;
}
.v-btn--outlined {
  border: 2px solid !important;
}
.semi-rounded {
  border-radius: 19px !important;
}
.v-application .v-main .rounded {
  border-radius: 25px !important;
}

// ALIGNMENT

.overflow-auto {
  overflow-y: auto;
}

.absolute-center {
  position: absolute !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.container {
  width: 100%;
  height: 100%;
}
.w-100 {
  width: 100%;
}
.h-100 {
  height: 100%;
}
.margin-auto {
  margin: auto;
}
.position-relative {
  position: relative;
}
// BACKGROUND
.v-main__wrap {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: unset;
  background: #fff;
}
.v-application--wrap {
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.v-application {
  background-image: var(--background-start) !important; /* Old browsers */
  background-image: -moz-linear-gradient(
    45deg,
    var(--background-start) 0%,
    var(--background-end) 100%
  ) !important; /* FF3.6-15 */
  background-image: -webkit-linear-gradient(
    45deg,
    var(--background-start) 0%,
    var(--background-end) 100%
  ) !important; /* Chrome10-25,Safari5.1-6 */
  background-image: linear-gradient(
    45deg,
    var(--background-start) 0%,
    var(--background-end) 100%
  ) !important; /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=var(--background-start), endColorstr=var(--background-end),GradientType=1 ) !important; /* IE6-9 fallback on horizontal gradient */
  background-blend-mode: overlay !important;
  background-color: var(--secondary-color) !important;
  &.iframe {
    background-color: #fefefe !important;
    overflow: auto;
    max-height: inherit;
    max-width: inherit;
  }
}
// COMPONENT STYLES
.section-title {
  font-size: 1.7rem;
  margin-bottom: 30px !important;
  margin-left: 5px;
  display: flex;
}

.section-title i,
.section-title svg {
  font-size: 1.8rem !important;
  margin-right: 12px;
}
a {
  transition: font-weight 0.1s ease-in-out;
  text-decoration: none;
}
.clickable {
  cursor: pointer;
}
.link {
  cursor: pointer;
  text-decoration: underline;
}
.disabled {
  opacity: 0.8;
  pointer-events: none;
}
.disable-events {
  pointer-events: none;
}
/* QR CODE */

.qr-code > img {
  margin: auto;
}
</style>
